import App from "./app";

// Подключение основного файла стилей
import "../scss/index.scss";

window.app = new App();